module.exports = __webpack_public_path__ + "media/images/icons/avatar_placeholder-caad65711204cf77b107adf70173ad40.svg";